import { LuPhone, LuCalendar, LuMapPin } from "react-icons/lu";
import { formatDate } from "../../../service/convert/date";
import { ICompanyBranch } from "../../../store/@types/company";

type IBranchCard = {
  branch: ICompanyBranch;
  isSelected: boolean;
  onSelect: () => void;
};

export const BranchCard = ({ branch, isSelected, onSelect }: IBranchCard) => {
  return (
    <div
      className={`p-6 cursor-pointer rounded-2xl shadow-md ${
        isSelected
          ? "bg-primary-700 text-white"
          : "bg-white border border-gray-50/5 shadow-sm text-gray-500"
      }`}
      onClick={onSelect}
    >
      <h5
        className={`text-xl font-semibold mb-2 capitalize ${
          isSelected ? "text-white" : "text-primary-500"
        }`}
      >
        {branch.state?.name}, {branch.state?.country?.name}
      </h5>
      <div className="space-y-2.5">
        {branch.company_phone && (
          <InfoRow
            icon={<LuPhone />}
            text={branch.company_phone || "N/A"}
            highlighted={isSelected}
          />
        )}
        <InfoRow
          icon={<LuCalendar />}
          text={branch.created_at ? formatDate(branch.created_at) : "N/A"}
          highlighted={isSelected}
        />
        <InfoRow
          icon={<LuMapPin />}
          text={branch.company_address}
          highlighted={isSelected}
        />
      </div>
    </div>
  );
};

const InfoRow = ({
  icon,
  text,
  highlighted,
}: {
  icon: React.ReactNode;
  text: string;
  highlighted: boolean;
}) => (
  <div className="flex items-center gap-2.5">
    <span className={highlighted ? "text-white" : "text-muted-foreground"}>
      {icon}
    </span>
    <span
      className={`text-sm ${highlighted ? "text-white" : "text-muted-foreground"}`}
    >
      {text}
    </span>
  </div>
);
